import { render, staticRenderFns } from "./CartPosDetailsModal.vue?vue&type=template&id=a2f14d52&scoped=true&"
import script from "./CartPosDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CartPosDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./CartPosDetailsModal.vue?vue&type=style&index=0&id=a2f14d52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f14d52",
  null
  
)

export default component.exports